import { render, staticRenderFns } from "./BalanceInputs.vue?vue&type=template&id=858a4438&"
import script from "./BalanceInputs.vue?vue&type=script&lang=js&"
export * from "./BalanceInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports